import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Users, Loader2, ArrowLeft, ExternalLink } from 'lucide-react';
import { getAuthorDetail } from '../services/cms';

const AuthorDetail = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { setData(null); setErr(false); getAuthorDetail(slug).then(setData).catch(() => setErr(true)); }, [slug]);

  if (err) return <div className="max-w-7xl mx-auto px-4 py-20 text-center"><p className="font-display text-xl mb-4">Auteur introuvable.</p><Link to="/auteurs" className="text-primary font-800">Retour</Link></div>;
  if (!data) return <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;
  const { author, comics } = data;

  return (
    <div className="max-w-6xl mx-auto px-4 py-10" data-testid="author-detail-page">
      <Link to="/auteurs" className="inline-flex items-center gap-2 font-700 mb-6 hover:text-primary transition-colors"><ArrowLeft className="w-4 h-4" /> Auteurs et autrices</Link>
      <div className="flex items-start gap-5 mb-10">
        <div className="w-20 h-20 rounded-full overflow-hidden bg-primary/10 flex items-center justify-center shrink-0">
          {author.portrait?.url
            ? <img src={author.portrait.url} alt={author.portrait.alt || `Portrait de ${author.name}`} className="w-full h-full object-cover" data-testid="author-detail-portrait" />
            : <Users className="w-9 h-9 text-primary" data-testid="author-detail-fallback" />}
        </div>
        <div>
          <h1 className="font-display font-700 text-3xl sm:text-4xl">{author.name}</h1>
          {author.description && <p className="text-foreground/75 mt-2 max-w-2xl">{author.description}</p>}
          {author.url && <a href={author.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-primary font-800 text-sm mt-2 hover:underline"><ExternalLink className="w-4 h-4" /> Profil sur citytoon.org</a>}
        </div>
      </div>

      <h2 className="font-display font-700 text-2xl mb-5">Webtoons</h2>
      {comics.length === 0 ? <p className="text-muted-foreground font-600">Aucun webtoon public.</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {comics.map((e) => (
            <Link key={e.source_id} to={`/fiche/${encodeURIComponent(e.slug)}`} data-testid={`author-comic-${e.slug}`} className="card-hover group bg-card rounded-2xl overflow-hidden border border-border">
              <div className="aspect-square overflow-hidden">{e.featured_image?.url ? <img src={e.featured_image.url} alt={e.titre} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" /> : <div className="w-full h-full bg-muted" />}</div>
              <div className="p-3"><h3 className="font-display font-600 text-sm line-clamp-2 group-hover:text-primary transition-colors">{e.titre}</h3></div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuthorDetail;
